import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, MANUFACTURE } = authRoles

const Inventories = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const inventoriesModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/inventory',
    name: 'inventory',
    component: Inventories,
    meta: {
      title: 'Inventario',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
